<template>
  <el-card shadow="never" style="border: none">
    <el-date-picker
      v-model="queryStartTime"
      type="datetime"
      size="mini"
      placeholder="开始时间"
      value-format="yyyy-MM-dd hh:mm:ss"
    />
    <el-date-picker
      v-model="queryEndTime"
      type="datetime"
      size="mini"
      placeholder="结束时间"
      value-format="yyyy-MM-dd hh:mm:ss"
      style="margin-left: 15px"
    />
    <el-button
      size="mini"
      :loading="loading0"
      style="margin-left: 15px"
      @click="queryHistory(mmsi, queryStartTime, queryEndTime)"
    >
      查询
    </el-button>
    <el-button
      size="mini"
      type="danger"
      :loading="removing"
      :disabled="!selections.length"
      style="margin-left: 15px"
      @click="removeVoyages"
    >
      删除
    </el-button>

    <el-table
      v-loading="loading0"
      :data="voyages || []"
      size="mini"
      max-height="400"
      style="margin-top: 15px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="ata" label="ATA" width="150" />
      <el-table-column prop="atBerthA" label="ATB_A" width="150" />
      <el-table-column prop="atBerthD" label="ATB_D" width="150" />
      <el-table-column prop="atd" label="ATD" width="150" />
      <el-table-column prop="portCode" label="港口代码">
        <div slot-scope="scope">
          {{ scope.row.portCode }}
          <div v-if="scope.row.portCode0" style="color: #999; margin-top: 2px">
            {{ scope.row.portCode0 }}
          </div>
        </div>
      </el-table-column>
      <el-table-column prop="portEnName" label="港口英文名" />
      <el-table-column prop="portCnName" label="港口中文名" />
    </el-table>
  </el-card>
</template>

<script>
import api from './api'

export default {
  mixins: [api],
  props: {
    mmsi: {
      type: Number,
    },

    version: {
      type: Number,
    },
  },

  data() {
    return {
      loading0: false,
      queryStartTime: '',
      queryEndTime: '',
      voyages: [],
      selections: [],

      removing: false,
    }
  },

  watch: {
    version() {
      this.voyages = []
      this.queryHistory(this.mmsi, this.queryStartTime, this.queryEndTime)
    },
  },

  mounted() {
    this.queryHistory(this.mmsi, this.queryStartTime, this.queryEndTime)
  },

  methods: {
    handleSelectionChange(selections) {
      this.selections = selections.map(k => k.id)
    },

    async removeVoyages() {
      this.removing = true

      try {
        const resp = await this.$api.post(
          '/trace/aiseventops/removeHistoryVoyages',
          this.selections
        )

        if (resp.data.status === 1) {
          await this.queryHistory(
            this.mmsi,
            this.queryStartTime,
            this.queryEndTime
          )
        }
      } finally {
        this.removing = false
      }
    },

    async queryHistory(mmsi, queryStartTime, queryEndTime) {
      if (!this.mmsi) {
        return
      }

      this.loading0 = true

      try {
        const resp = await this.$api.get(
          '/trace/aiseventops/queryHistoryVoyage',
          {
            params: {
              mmsi,
              btm: queryStartTime,
              etm: queryEndTime,
            },
            baseURL: '/',
          }
        )

        if (resp.data.status === 1) {
          this.voyages = resp.data.content || []
        }
      } finally {
        this.loading0 = false
      }
    },
  },
}
</script>

<style></style>
